import React, { Component, Fragment, useContext } from 'react'
import { Alert, Checkbox, message, Popconfirm, Radio, Select, Tabs } from "antd"
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import { validateEmailList} from './helpers'
import {
  Icon,
  Tooltip,
  Dropdown,
  Menu,
  Row,
  Col,
  Button,
  Spin,
  Input,
  TextArea,
  FormItem,
  Link,
  Search,
} from '../../common/UIComponents'

import {
  alertMessage,
  base64ToPdf,
  isEmpty,
  randomNumber,
} from '../../common/Common'
import I18n from '../../common/I18n'
import BaseModal from '../BaseModal'
import Invoice from './Invoice'
import expandIcon from '../../../assets/images/file-expand-icon.png'
import AppConfig from '../../config/AppConfig'
import {
  fetchConsolidatedInvoicePdf,
  fetchInvoiceRemarks,
  fetchOrderInvoicePdf,
  getContactEmails,
  getEmailSubjectLine,
  fetchAttachments,
  saveInvoiceRemark,
  SendInvoiceEmail,
} from '../../api/Billing'
import { checkServiceExistance, renderAlertMessage } from '../../helpers/common'
import userStore from '../../stores/UserStore'
import AddOrdersToInvoice from './AddOrdersToInvoice'
import PostInvoiceToQB from './PostInvoiceToQB'
import EmailsInput from '../../containers/Modals/EmailsInput';
import UnlockInvoice from './UnlockInvoice'
import { checkListApi } from '../../api/CheckList'
import InvoiceActivitiesList from '../billing/InvoicesActivitiesList'
import { InvoicesActivitiesApi } from '../../api/InvoicesActivitiesApi'
import { OrgContext } from '../../context/OrgContext'
import PropTypes from "prop-types";
import BillingActivitiesList from '../billing/BillingActivitiesList'
import NoteMessage from '../NoteMessage'
import { UserContext } from '../../context/UserContext'
import { base64ToBlob,printFile,} from '../../common/preview'
import MixedGallery from '../../stories/MixedGallery'
import FilePreviewViewer from '../../common/FilePreviewViewer'
import InvoiceOrderAttachments from './InvoiceOrderAttachments'
import { sendInvoiceEDIStatus } from '../../api/BillingScreenAPI'
import InvoicePayments from './InvoicePayments'
import InvoiceChargesContainer from "../../../javascripts/components/billing/InvoiceCharges/InvoiceChargesContainer";
import { InvoiceEmailActivities } from './InvoiceEmailActivities'
import Remarks from '../billing/Remarks'

const {TabPane} = Tabs

const ChipCheckbox = ({ checked, onChange, label, dataTestId }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const styles = {
    container: {
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      padding: "6px 12px",
      borderRadius: "6px",
        border: `1px solid ${checked ? "#576ec1" : "#cfcfcf"}`,
      backgroundColor: isHovered 
        ? (checked ? "#576ec1" : "#f5f5f5") 
        : (checked ? "#576ec1" : "white"),
      cursor: "pointer",
      userSelect: "none",
      marginRight: "10px",
      transition: "background-color 0.2s ease"
    },
    circle: {
      width: "18px",
      height: "18px",
      borderRadius: "50%",
      border: `1px solid ${checked ? "#fff" : "#576ec1"}`,
      backgroundColor: checked ? "#fff" : "transparent",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
    },
    label: {
      fontWeight: "500",
      color: checked ? "#fff" : "#576ec1"
    }
  };

  return (
    <div 
      data-testid={dataTestId}
      style={styles.container} 
      onClick={() => onChange(!checked)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={styles.circle}>
        {checked && <Icon type="check" style={{ color : checked ? "#576ec1" : "#999" }} />}
      </div>
      <span style={styles.label}>{label}</span>
    </div>
  );
};

class ShowInvoiceComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: this.props.account,
      invoiceNo: this.props.invoice_no,
      showForm: false,
      isGeneratingPdf: false,
      status: this.props.status,
      isInvoiceModified: false,
      isSendingMail: false,
      showEmailModal: false,
      isEmailLoading:false,
      invoiceEmails: [],
      contacts: [],
      subject: "",
      subPrefix: "",
      description: "",
      includePODs: true,
      signatures : false,
      bols : false,
      drivers : false,
      checkList: this.props.checkList,
      accountInvoices: this.props.accountInvoices,
      customerOrderIds: this.props.customerOrderIds,
      is_locked: this.props.is_locked == true,
      is_file_generated: this.props?.is_file_generated ? this.props.is_file_generated : false,
      account_invoice_id: this.props.account_invoice_id,
      activeKey:'details',
      activityData: [],
      isLoading: false, 
      showInvoiceActions : this.props.showInvoiceActions,
      showActions: !isEmpty(this.props.showActions) ? this.props.showActions : true,
      approvalDate: !isEmpty(this.props.approvalDate) ? this.props.approvalDate : "",
      renderType: !isEmpty(this.props.renderType) ? this.props.renderType : "icon",
      vendorNo: "",
      remarkSaveLoading: false,
      remarks: [],
      newRemark: "",
      showRemarks: false,
      expandedRowKeys: [],
      blobUrl: null,
      fileName: null,
      fileType: 'pdf',
      files: [],
      showPreview: false,
      customizeMessage: true,
      emailAttachments: [],
      categoryCounts: {
        pods: { total: 0, selected: 0 },
        bols: { total: 0, selected: 0 },
        signatures: { total: 0, selected: 0 },
        drivers: { total: 0, selected: 0 }
      },
      attachmentSummary: { totalSelected: 0, totalOrders: 0 },
      isLoadingAttachments: false,
      ediStatusSending:false,
      totalDetails: [],
      fetchCurrentInvoiceDetails: false,
      screenFrom: this.props?.screenFrom ? this.props.screenFrom : "INVOICES",
      hasChargesModified: false,
    }
    this.attachmentsRef = React.createRef();
  }

  // Update the renderEmailModal method:
  addInvoiceEmail = (value) => {
    const validEmails = validateEmailList(value);
    this.setState({ invoiceEmails: validEmails });
  };
  showInvoiceForm = () => {
    this.setState({
      showForm: true,
      driverRates: [],
    })
    this.getInvoiceActivities();
  }

  componentDidMount() {
    if (this.props.autoOpen && !this.state.showForm) {
      this.showInvoiceForm();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.autoOpen && !prevProps.autoOpen && !this.state.showForm) {
      this.showInvoiceForm();
    }
    
    if (this.props.autoOpen && 
        this.props.account_invoice_id !== prevProps.account_invoice_id) {
      if (this.state.showForm) {
        this.setState({
          showForm: false,
          driverRates: [],
        });
      }
      
      setTimeout(() => {
        this.setState({
          account: this.props.account,
          invoiceNo: this.props.invoice_no,
          account_invoice_id: this.props.account_invoice_id,
        }, () => {
          this.showInvoiceForm();
        });
      }, 100);
    }
  }

  // componentDidUpdate (prevProps, prevState) {
  //   if (this.state.is_locked !== this.props.is_locked) {
  //     this.setState({
  //       is_locked: this.props.is_locked == true,
  //     })
  //   }
  // }
  handleOnModalClose = () => {
    this.setState({
      showForm: false,
      driverRates: [],
    },
    //  () => {
    //   if (this.state.isInvoiceModified) {
    //     this.props.refreshList();
    //   }
    // }
  )
    if (this.props.autoOpen && this.props.history) {
      this.props.history.replace({
        ...this.props.history.location,
        state: {
          ...this.props.history.location.state,
          activeRecordId: undefined
        }
      });
    }
  }

  setRef = (ref) => (this.componentRef = ref)

  printOrderInvoice = (customer_order_id, invoiceNo) => {
    message.loading({
      key: "download",
      content: "Generating files...",
    });
    this.setState({
      isGeneratingPdf: true,
    })
    fetchOrderInvoicePdf(customer_order_id, invoiceNo)
      .then((result) => {
        if (result.success) {
          if (result.file_type === 'BOTH') {
            // For PDF, show preview
            const pdfBlobUrl = this.obtainBlobUrl(result.bol_file.pdf_file_obj, 'application/pdf');
            
            // For Excel, show in preview with download option
            const excelBlobUrl = this.obtainBlobUrl(result.bol_file.excel_file_obj, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            
            this.setState({
              files: [
                {
                  type: 'pdf',
                  fileUrl: pdfBlobUrl,
                  originalTitle: `OrderInvoice-${invoiceNo}.pdf`
                },
                {
                  type: 'excel',
                  fileUrl: excelBlobUrl,
                  originalTitle: `OrderInvoice-${invoiceNo}.xlsx`
                }
              ],
              showPreview: true
            });
          } else if (result.file_type === 'EXCEL') {
            const excelBlobUrl = this.obtainBlobUrl(result.bol_file, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            
            this.setState({
              files: [
                {
                  type: 'excel',
                  fileUrl: excelBlobUrl,
                  originalTitle: `OrderInvoice-${invoiceNo}.xlsx`
                }
              ],
              showPreview: true
            });
          } else {
            const pdfBlobUrl = this.obtainBlobUrl(result.bol_file, 'application/pdf');
            
            this.setState({
              files: [
                {
                  type: 'pdf',
                  fileUrl: pdfBlobUrl,
                  originalTitle: `OrderInvoice-${invoiceNo}.pdf`
                }
              ],
              showPreview: true
            });
          }
          message.destroy();
        } else {
          message.destroy();
          renderAlertMessage(result.errors)
        }
      })
      .finally(() => {
        this.setState({
          isGeneratingPdf: false,
        })
      })
  }

  printConsolidateInvoice = () => {
    message.loading({
      key: "download",
      content: "Generating files...",
    });
    this.setState({
      isGeneratingPdf: true,
    })
    const org_id = userStore.getStateValue('selectedOrg')
    fetchConsolidatedInvoicePdf(
      this.state.account,
      this.state.invoiceNo,
      org_id,
    )
      .then((result) => {
        if (result.success) {
          if (result.file_type === 'BOTH') {
            // For PDF, show preview
            const pdfBlobUrl = this.obtainBlobUrl(result.bol_file.pdf_file_obj, 'application/pdf');
            
            // For Excel, show in preview with download option
            const excelBlobUrl = this.obtainBlobUrl(result.bol_file.excel_file_obj, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            
            this.setState({
              files: [
                {
                  type: 'pdf',
                  fileUrl: pdfBlobUrl,
                  originalTitle: `ConsolidateInvoice-${this.state.invoiceNo}.pdf`
                },
                {
                  type: 'excel',
                  fileUrl: excelBlobUrl,
                  originalTitle: `ConsolidateInvoice-${this.state.invoiceNo}.xlsx`
                }
              ],
              showPreview: true
            });
          } else if (result.file_type === 'EXCEL') {
            const excelBlobUrl = this.obtainBlobUrl(result.bol_file, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            
            this.setState({
              files: [
                {
                  type: 'excel',
                  fileUrl: excelBlobUrl,
                  originalTitle: `ConsolidateInvoice-${this.state.invoiceNo}.xlsx`
                }
              ],
              showPreview: true
            });
          } else {
            // For PDF only, show preview using MixedGallery
            const pdfBlobUrl = this.obtainBlobUrl(result.bol_file, 'application/pdf');
            
            this.setState({
              files: [
                {
                  type: 'pdf',
                  fileUrl: pdfBlobUrl,
                  originalTitle: `ConsolidateInvoice-${this.state.invoiceNo}.pdf`
                }
              ],
              showPreview: true
            });
          }
          message.destroy();
        } else {
          message.destroy();
          renderAlertMessage(result.errors)
        }
      })
      .finally(() => {
        this.setState({
          isGeneratingPdf: false,
        })
      })
  }

   sendEdiInvoices = async () => {
      this.setState({ ediStatusSending: true });
  
      try {
        const payload = {
          account_invoice_ids: [this.props.account_invoice_id],
          organization_id: userStore.getStateValue("selectedOrg"),
        };
  
        const response = await sendInvoiceEDIStatus(payload);
  
        if (response?.success) {
          alertMessage(response?.message || "EDI Invoice sent successfully");
        } else {
          renderAlertMessage(response?.errors || "Failed to send EDI Invoice");
        }
      } catch (error) {
        console.error("Error in sending EDI status:", error);
        renderAlertMessage("An unexpected error occurred while sending EDI Invoice");
      } finally {
        this.setState({ ediStatusSending: false });
      }
    };

  obtainBlobUrl = (base64, type) => {
    const blob = base64ToBlob(base64, type);
    const blobUrl = URL.createObjectURL(blob);
    return blobUrl;
  }

  printInvoice = (customer_order_id) => {
    if (this.props.invoice_type === 'INDV') {
      this.printOrderInvoice(customer_order_id, this.state.invoiceNo)
    } else {
      this.printConsolidateInvoice()
    }
  }

  setInvoiceDetails = ({ invoiceDetails, isLocked = false, totalDetails, vendorNo, billingCompanyDetails = {}, isEmailed = "false" }) => {
    this.setState({
      invoiceDetails: invoiceDetails,
      totalDetails: totalDetails || [],
      is_locked: isLocked,
      isInvoiceModified: true,// TO DO
      vendorNo,
      billingCompanyDetails,
      isEmailed
    })
  }

  handleAddOrdersSuccess = () => {
    this.setState({
      key: randomNumber(3),
      isInvoiceModified: true,
    })
  }

  handleApproveSuccess = (status,invoiceNo,statusChange) => {
    this.setState({
      key: randomNumber(3),
      status,
      isInvoiceModified: true,
    }), () => {
      this.props.onUnmount(invoiceNo,statusChange)
    }
  }

  getEmails = () => {
    const { account } = this.props;
    const accountId = account
    this.setState({isEmailLoading:true})
    getContactEmails(accountId).then((result) => {
      if (result.success) {
        this.setState({
          contacts: result.contact_emails || [],
          isEmailLoading:false
        })
      }else{
        alertMessage(result.errors[0], "error", 10);
        this.setState({ isEmailLoading: false, contacts: [] });
      }
    })
  }

getAttachments = async () => {
  const {
    currentOrg,
    accountInvoices,
    account_invoice_id,
    customerOrderIds: customerOrderIdsFromProps
  } = this.props;

  let customerOrderIds = [];

  // PRIORITY 1: customerOrderIds passed directly as props
  if (Array.isArray(customerOrderIdsFromProps) && customerOrderIdsFromProps.length) {
    customerOrderIds = customerOrderIdsFromProps;
  } 
  // PRIORITY 2: Extract from invoiceDetails (totalDetails) array from Invoice component API response
  else if (Array.isArray(this.state.totalDetails) && this.state.totalDetails.length > 0) {
    customerOrderIds = this.state.totalDetails
      .map(invoice => invoice.customer_order_id)
      .filter(id => id != null && id !== undefined);
  }
  // FALLBACK: derive from accountInvoices
  else {
    let invoices = [];

    if (Array.isArray(accountInvoices)) {
      invoices = accountInvoices;
    } else if (Array.isArray(accountInvoices?.invoices)) {
      invoices = accountInvoices.invoices;
    } else if (accountInvoices && typeof accountInvoices === "object") {
      invoices = [accountInvoices];
    }

    const matchedInvoice =
      invoices.find(
        inv => inv.id === account_invoice_id || inv._id === account_invoice_id
      ) || invoices[0] || null;

    // Case 1: multiple invoices → customer_order_ids on invoice
    if (Array.isArray(matchedInvoice?.customer_order_ids)) {
      customerOrderIds = matchedInvoice.customer_order_ids;
    }
    // Case 2: single invoice response → customer_order_id
    else if (accountInvoices?.customer_order_id) {
      customerOrderIds = [accountInvoices.customer_order_id];
    }
    // Case 3: single invoice → customer_order_ids (singular naming)
    else if (accountInvoices?.customer_order_ids) {
      customerOrderIds = Array.isArray(accountInvoices.customer_order_ids)
        ? accountInvoices.customer_order_ids
        : [accountInvoices.customer_order_ids];
    }
  }

  const payload = {
    organization_id: currentOrg?.id,
    order_ids: customerOrderIds
  };

  this.setState({ isLoadingAttachments: true });

  try {
    const result = await fetchAttachments(payload);

    if (result.success) {
      this.setState(
        {
          emailAttachments: result.email_attachments || [],
        },
        () => {
          if (this.attachmentsRef?.current) {
            const counts = this.attachmentsRef.current.getCategoryCounts();
            if (counts) this.setState({ categoryCounts: counts });

            const summary = this.attachmentsRef.current.getTotalSelectedCount();
            if (summary) this.setState({ attachmentSummary: summary });
          }
        }
      );
    } else {
      this.setState({ emailAttachments: [] });
      alertMessage(result.errors[0], "error", 10);
    }
  } catch (error) {
    console.error("Error fetching attachments:", error);
    this.setState({ emailAttachments: [] });
  } finally {
    this.setState({
      showEmailModal: true,
      isLoadingAttachments: false,
    });
  }
};

getEmailSubject = async () => {
  const { organizationSettings } = this.props;
  // const { invoice_body_text } = organizationSettings;
  const { currentOrg, invoice_no } = this.props;
  const payload = {
    organization_id: currentOrg.id,
    invoice_number: this.state.invoiceNo,
    setting_name: "invoice_email_subject",
  };

  const defaultSubject =
    currentOrg.code === "HILL" &&
    !_.isEmpty(this.state.billingCompanyDetails.name)
      ? `${this.state.billingCompanyDetails.name} #${invoice_no} Invoice`
      : `${invoice_no} Invoice`;

  try {
    const result = await getEmailSubjectLine(payload);

    if (result.success) {
      const emailSubject = result?.subject ? result.subject : defaultSubject;
      this.setState({
        subject: emailSubject,
      });
    } else {
      this.setState({
        subject: defaultSubject,
      });
      alertMessage(result.errors[0], "error", 10);
    }
  } catch (error) {
    console.error("Error fetching email subject:", error);
  } finally {
    this.setState({
      showEmailModal: true,
      // description: invoice_body_text || I18n.t("configurations.default_email_body_message"),
    });
  }
};

getEmailBody = async () => {
  const { currentOrg, invoice_no } = this.props;
  const payload = {
    organization_id: currentOrg.id,
    invoice_number: this.state.invoiceNo,
    setting_name: "invoice_body_text",
  };

  const defaultSubject = I18n.t("configurations.default_email_body_message");
  let emailBody;

  try {
    const result = await getEmailSubjectLine(payload);

    if (result.success) {
      emailBody = result?.subject ? result.subject : defaultSubject;
    } else {
      alertMessage(result.errors[0], "error", 10);
    }
  } catch (error) {
    console.error("Error fetching email body:", error);
  } finally {
    this.setState({
      showEmailModal: true,
      description: emailBody,
    });
  }
};

getEmailSubjectPrefix = async () => {
  const { currentOrg} = this.props;
  const payload = {
    organization_id: currentOrg.id,
    invoice_number: this.state.invoiceNo,
    setting_name: "invoice_email_subject_prefix_value",
  };


  try {
    const result = await getEmailSubjectLine(payload);
    const { is_revised } = result;

    if (result.success) {
      // ony if is_revised is true
      if (is_revised) {
        const subjectPrefix = result?.subject ? result.subject : " ";

        const currentSubject = this.state.subject || '';
        let finalSubject = currentSubject;
        
        if (currentSubject && !currentSubject.startsWith(subjectPrefix)) {
          finalSubject = `${subjectPrefix} ${currentSubject}`;
        }
        
        this.setState({
          subPrefix: subjectPrefix,
          subject: finalSubject !== currentSubject ? finalSubject : currentSubject
        });
      }
    } else {
      this.setState({
        subPrefix: "",
      });
      alertMessage(result.errors[0], "error", 10);
    }
  } catch (error) {
    console.error("Error fetching email subject prefix:", error);
  } 
};

fetchCurrentInvoiceData = (val) => {
  this.setState({ fetchCurrentInvoiceDetails: val });
}

  handleSendingMails = () => {
    if (!this.state.invoiceEmails.length) return alertMessage('Please enter atleast one email address', 'error');

    const { account } = this.props;
    
    // Get email attachments payload from the component ref
    let email_attachments = {};
    if (this.attachmentsRef && this.attachmentsRef.current) {
      email_attachments = this.attachmentsRef.current.getEmailAttachmentsPayload() || {};
    }
    
    const payload = {
      account_id: account,
      invoice_number: this.state.invoiceNo,
      organization_id: userStore.getStateValue('selectedOrg'),
      email_ids: this.state.invoiceEmails,
      email_attachments: Object.keys(email_attachments).length > 0 ? email_attachments : undefined
    };

    // Only include subject and description if customizeMessage is checked
    if (this.state.customizeMessage) {
      const finalSubject = this.state.subject || this.state.subPrefix || '';
      payload.subject = finalSubject;
      payload.description = this.state.description;
    }
    this.setState({ isSendingMail: true });
    SendInvoiceEmail(payload).then((result) => {
      if (result.success) {
        alertMessage(result.message, 'success', 5);
        this.setState({
          showEmailModal: false,
          fetchCurrentInvoiceDetails: true,
        });
      } else {
        alertMessage(result.errors, 'error', 5);
      }
    }
    ).finally(() => { this.setState({ isSendingMail: false }); }
    );
  }

  showRemarksForm = () => {
    this.setState({ showRemarks: true });
  };

  closeRemarksForm = () => {
    this.setState({ showRemarks: false, newRemark: "" });
  };

  onSaveRemark = async () => {
    const remarkText = this.state.newRemark?.trim();
    if (!remarkText) {
      return;
    }

    this.setState({
      remarkSaveLoading: true,
    });
    try {
      const payload = {
        organization_id: userStore.getStateValue('selectedOrg'),
        account_invoice_id: this.props.account_invoice_id ? this.props.account_invoice_id : '',
        remarks: remarkText,
      };
      const response = await saveInvoiceRemark(payload);

      if (response?.success) {
        const msg = response?.message ? response.message : "Saved Successfully!!";
        alertMessage(msg, "success", 10);
        this.setState({ newRemark: "", showRemarks: false }, () => {
          this.getInvoiceRemarks();
        });
      } else {
        renderAlertMessage(response?.errors);
      }
    } catch (error) {
      console.error("error in getting Invoice remark response");
    } finally {
      this.setState({
        remarkSaveLoading: false,
      });
    }
  }

  _rederRemarkForm = () => {
    const status = this.state.status;
    const canAddRemarks = status !== "APPROVED" || this?.props?.enableRemarks;
    const { remarks, newRemark, remarkSaveLoading, showRemarks } = this.state;

    return (
      <Fragment>
        <div data-testid="remark-tab">
          <Spin spinning={remarkSaveLoading}>
            {remarks.length > 0 && (
              <Row>
                <Col span={24}>
                  <FormItem label={I18n.t("general.remarks")}>
                    <Remarks data={remarks} timeZoneId={this.props.timeZoneId} />
                  </FormItem>
                </Col>
              </Row>
            )}
            {canAddRemarks && !showRemarks && (
              <Row>
                <Col span={24} className="alignRight billing-add-notes-action">
                  <Button
                    type="link"
                    size="small"
                    onClick={this.showRemarksForm}
                  >
                    <Icon type="plus-circle" />
                    &nbsp;{I18n.t("invoices.add_remarks")}
                  </Button>
                </Col>
              </Row>
            )}
            {canAddRemarks && showRemarks && (
              <Row>
                <Col span={24}>
                  <FormItem label={I18n.t("invoices.add_remarks")}>
                    <TextArea
                      data-testid="remark-textarea"
                      rows={4}
                      placeholder={I18n.t("general.remarks")}
                      className="sop-form-textArea"
                      value={newRemark}
                      onChange={(e) => this.setState({ newRemark: e.target.value })}
                    />
                    <div style={{ textAlign: "center" }}>
                      <Button onClick={this.closeRemarksForm} icon="close">
                        {I18n.t("general.cancel")}
                      </Button>
                      <Button
                        data-testid="save-button"
                        type="primary"
                        loading={remarkSaveLoading}
                        disabled={!newRemark?.trim()}
                        onClick={this.onSaveRemark}
                        className="assignDriver"
                        style={{ margin: 10 }}
                        icon="save"
                      >
                        {I18n.t("general.save")}
                      </Button>
                    </div>
                  </FormItem>
                </Col>
              </Row>
            )}
          </Spin>
        </div>
      </Fragment>
    );
  }

  showEmailModal = (emails = null) => {
    const { organizationSettings } = this.props;
    const { invoice_body_text } = organizationSettings;
    this.getEmailSubject()
    this.getEmails();
    this.getEmailBody();
    this.getEmailSubjectPrefix();
    this.getAttachments();

    if (emails && Array.isArray(emails)) {
      this.setState({ invoiceEmails: emails });
    } else {
      this.setState({ invoiceEmails: [] });
    }
  }
  goToTab = (key) => {
    this.setState({
      activeKey: key,
    },()=>{
      if (key === "remarks") {
        this.getInvoiceRemarks();
      }
      if(key === "activities"){
        this.getInvoiceActivities();
      }
      if (key === "details" && this.state.hasChargesModified) {
        this.setState({
          fetchCurrentInvoiceDetails: true,
          hasChargesModified: false, // reset immediately, one-shot trigger
        });
      }
    });
  };
   getInvoiceActivities = async() => {
    this.setState({
      isLoading: false,
    })
    await InvoicesActivitiesApi.fetchInvoiceActivity({
      organization_id: userStore.getStateValue('selectedOrg'),
      invoice_id: this.props.account_invoice_id
      ? this.props.account_invoice_id
      : ''
    })
      .then((response) => {
        console.log('Invoice API---->',response)
        if (response.success) {
          this.setState({
            activityData: response.invoice_activity || []
          })
        } else {
          alertMessage(response.errors.join(","), "error", 10);
        }
      })
      .catch((error) => {
        alertMessage(error, "error", 10);
        // handle error response
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      });
  };

  getInvoiceRemarks = async () => {
    this.setState({
      isLoading: true,
    });

    try {
      const payload = {
        organization_id: userStore.getStateValue("selectedOrg"),
        account_invoice_id: this.props.account_invoice_id || "",
      };

      const response = await fetchInvoiceRemarks(payload);

      if (response?.success) {
        const rawRemarks = response.invoiceRemarks;
        const remarks = Array.isArray(rawRemarks)
          ? rawRemarks
          : rawRemarks
            ? [{ remark: rawRemarks }]
            : [];
        this.setState({
          remarks,
        });
      } else {
        renderAlertMessage(response?.errors);
      }
    } catch (error) {
      console.error("Error fetching invoice remarks:", error);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  renderFormModal = () => {
    const { isEmailed, invoiceNo } = this.state;
    const emailStatus = isEmailed === "true" ? (
      <span style={{ fontSize: "14px", marginLeft: "10px" }}>
        <span className="textRed" style={{ fontSize: "30px", verticalAlign: "middle" }}>*</span>{" "}
        <span className="textGreen">Invoice email sent.</span>
      </span>
    ) : (
      <span style={{ fontSize: "14px", marginLeft: "10px" }}>
        <span className="textRed" style={{ fontSize: "30px", verticalAlign: "middle" }}>*</span>{" "}
        <span className="textRed">Pending Invoice email.</span>
      </span>
    );

    const title = (
      <span>
        {`${I18n.t("invoices.label")} #${invoiceNo}`}
        {/* {emailStatus} */}
      </span>
    );
    const invoiceId = this.props.account_invoice_id
      ? this.props.account_invoice_id
      : ''
      const selectedInfo = this.props.selectedInfo
    const menu = (
      <Menu onClick={(e) => this.handleExportChange(e.key)}>
        {Object.keys(AppConfig.exportOptions).map((key) => (
          <Menu.Item key={key}>{AppConfig.exportOptions[key]}</Menu.Item>
        ))}
      </Menu>
    )
    const status = this.state.status;
    const {isSendingMail, is_locked, showActions,showInvoiceActions } = this.state
    const isLocked = is_locked == true
    return (
      <BaseModal
        title={title}
        onCancel={() => this.handleOnModalClose()}
        style={{ top: 30 }}
        width="90%"
      >
          <div className="child-card-container" data-testid="invoice-modal">
          <Tabs
            onChange={this.goToTab}
            activeKey={this.state.activeKey}
            size="small"
            type="card"
            tabBarExtraContent={isLocked && !(this.props.inBillingScreen) ? <Button data-testid="invoice-locked-tab-button" type="danger" icon="lock" size="small">{I18n.t('general.locked')}</Button> : <Fragment />}
          >
          <TabPane tab={I18n.t("general.details")} key="details">  
        {showActions && (<Row data-testid="details-tab" type='flex' justify='center' align='middle' gutter={ 4 } style={{
          marginBottom: '10px',
        }}>
  
          {checkServiceExistance('GOIP') && (
            <Col>
              <Button
                data-testid="invoice-download-and-print-button"
                type="default"
                size="small"
                icon="printer"
                className="buttonGreen"
                disabled={this.state.isLoading || _.isEmpty(this.state.invoiceDetails?.customer_order_id) }
                onClick={() =>
                  this.printInvoice(
                    this.state.invoiceDetails.customer_order_id,
                  )
                }
              >
                {"Download / " + I18n.t('general.print')}
              </Button>
            </Col>
          )}
          {
            checkServiceExistance('PITQB') && showInvoiceActions && (
              <Col>
                <PostInvoiceToQB
                  buttonType="danger"
                  isDisabled={!invoiceId || isLocked}
                  label={status === 'PENDING' ? I18n.t('invoices.approve') : I18n.t('invoices.reapprove')}
                  invoiceIds={[invoiceId]}
                  handleSuccess={() => this.handleApproveSuccess('APPROVED',"",true)}
                  size="small"
                  checkListData={this.state.checkList}
                  enableChecklistApproval={this.props.enableChecklistApproval}
                  selectedInfo={selectedInfo}
                  indexList={false}
                  handleUnmount={this.props.onUnmount}
                  accountInvoices={this.props.accountInvoices}
                  dataTestId="invoice-approve-button"
                />
              </Col>
            )
          }
          {false && status === 'APPROVED' &&
            checkServiceExistance('PITQB') && showInvoiceActions && (
              <Col>
                <PostInvoiceToQB
                  buttonType="danger"
                  isDisabled={false}
                  label={I18n.t('invoices.push_to_qb')}
                  invoiceIds={[invoiceId]}
                  size="small"
                  checkListData={this.state.checkList}
                  enableChecklistApproval={this.props.enableChecklistApproval} 
                  handleSuccess={this.props.onUnmount}
                  selectedInfo={this.props.selectedInfo}
                  accountInvoices={this.props.accountInvoices}
                  dataTestId="invoice-approve-button"
                />
              </Col>
            )}
          {checkServiceExistance('IAO') && showInvoiceActions && (
            <Col>
              <AddOrdersToInvoice
                buttonType="primary"
                isDisabled={false || isLocked}
                label={`${I18n.t('general.add')} ${I18n.t('menu.orders')}`}
                handleSuccess={this.handleAddOrdersSuccess}
                invoiceId={invoiceId}
                size="small"
              // handleCancel={handleCancel}
              />
            </Col>
          )}
                {
                // !this.state.is_file_generated &&
          <Col>
                    <Button
                      data-testid="invoice-send-email"
                      type="primary"
                      size="small"
                      icon="mail"
                      disabled={this.state.isLoading}
                      onClick={this.showEmailModal}
                      loading={isSendingMail}
                      style={
                        !this.state.isLoading
                          ? {
                            backgroundColor: '#1890ff',
                            borderColor: '#1890ff',
                            color: '#fff',
                          }
                          : {}
                      }
                    >
              {I18n.t('general.send_item', { item: I18n.t('general.invoice') })}
            </Button>
                  </Col>}
                  {this.props.status === "APPROVED" && (
                    <Col>
                      <Button
                        data-testid="invoice-send-edi-button"
                        type="primary"
                        icon={"export"}
                        size='small'
                        onClick={this.sendEdiInvoices}
                        loading={this.state.ediStatusSending}
                        // disabled={disableEDIButton}
                        style={{
                          backgroundColor: "#01aeff",
                          borderColor: "#01aeff",
                          color: "#fff",
                          marginLeft: "6px",
                        }}
                      >
                        {I18n.t("invoices.send_edi_invoice")}
                      </Button>
                    </Col>
                  )}
           
          {/* {
            isLocked && <UnlockInvoice
            buttonType="primary"
            isDisabled={!isLocked}
            label={I18n.t('invoices.unlock')}
            invoiceIds={invoiceId}
            handleSuccess={this.handleAddOrdersSuccess}
            size="small"
          />
          } */}
        </Row>)}

        <Spin spinning={this.state.isGeneratingPdf} delay={1000}>
          <Invoice
            setIsLoading={(val) => this.setState({ isLoading: val })}
            orgRules={this.props.orgRules}
            currentOrg={this.props.currentOrg}
            accountUnitContext={this.props.accountUnitContext}
            orgSettings={this.props.orgSettings}
            isFileGenerated={this.state.is_file_generated}
            accountId={ this.state.account }
            invoiceNo={ this.state.invoiceNo }
            account_invoice_id= {this.state.account_invoice_id}
            setInvoiceDetails={ this.setInvoiceDetails }
            key={ this.state.key }
            showActions={this.state.showActions}
            approvalDate={this.props.approvalDate}
            invoiceApprovalDate={this.props.invoiceApprovalDate}
            showInvoiceActions = {showInvoiceActions}
            status={this.props.status}
            onUnmount={this.props.onUnmount}
            timeZoneId={this.props.timeZoneId}
            selectedInfo={selectedInfo}
            handleOnModalClose={this.handleOnModalClose}
            organizationSettings={this.props.organizationSettings}
            fetchCurrentInvoiceData={this.fetchCurrentInvoiceData}
            fetchCurrentInvoiceDetails={this.state.fetchCurrentInvoiceDetails}
            screenFrom={this.props?.screenFrom}
          />
        </Spin>
          </TabPane>
          {/* New Charge Tab — only when org Rule enable_invoice_charges_tab === true */}
          {_.get(this.props.orgRules, "org_billing_rules.enable_invoice_charges_tab") === "true" && (
            <TabPane tab={I18n.t("invoices.charges")} key="invoice_charges">
              <InvoiceChargesContainer
                invoice_orders={this.state.totalDetails}
                currentOrg={this.props.currentOrg}
                accountInvoiceId = {this.props.account_invoice_id}
                accountId={ this.state.account }
                // API to fetch email items to send invoice
                callEmailApi={this.showEmailModal}
                isFetchingDetails={this.state.isLoading}
                onChargesModified={() => this.setState({ hasChargesModified: true })}
              />
            </TabPane>
          )}
            {!this.props.inBillingScreen &&
             <TabPane tab="Activities" key="activities">
                {/* <NoteMessage message="The plus(+) icon allows you to expand and view billing activities interspersed between the invoice activities." /> */}

             <InvoiceActivitiesList data={this.state.activityData}
               timeZone="UTC"
               isMilitaryTime={true}
               timeZoneName="UTC"
              //  expandedRowRender={(record, index) => (
              //   <BillingActivitiesList
              //     data={this.state.activityData[index]?.difference?.billing_difference || []}
              //   />
              //  )}
               
              //  expandedRowKeys={this.state.expandedRowKeys}
              //  setExpandedRowKeys={(keys) => this.setState({ expandedRowKeys: keys })}
              //  onExpand={ (expanded, record) => {
              //   const keys = [];
              //   if (expanded) {
              //     // Use the index as the key since we're working with array indices
              //     const recordIndex = this.state.activityData.findIndex(item => 
              //       item === record
              //     );
              //     keys.push(recordIndex);
              //   }
              //   this.setState({ expandedRowKeys: keys });
              // }}
             />
           </TabPane>
            }
            <TabPane tab={"Email Activities"} key={"Email Activities"}>
              <InvoiceEmailActivities 
                onResendAll={this.showEmailModal}
                onResendFailed={this.showEmailModal}
                accountInvoiceId={this.state.account_invoice_id}
                organizationId={userStore.getStateValue('selectedOrg')}
                fetchCurrentInvoiceDetails={this.state.fetchCurrentInvoiceDetails}
                fetchCurrentInvoiceData={this.fetchCurrentInvoiceData}
                activeTab={this.state.activeKey}
              />
            </TabPane>
            <TabPane tab={I18n.t("general.remarks")} key="remarks">
              {this._rederRemarkForm()}
            </TabPane>
            <TabPane tab="Payments" key="payments">
              <InvoicePayments accountInvoiceId = {this.props.account_invoice_id} activeTab={this.state.activeKey}/>
            </TabPane>
        </Tabs>
        </div>
       
      </BaseModal>
    )
  }


renderEmailModal = () => {
  const prefix = this.state.subPrefix || '';
  const subject = this.state.subject || '';
  
  let fullSubject;
  if (subject) {
    fullSubject = subject;
  } else if (prefix) {
    fullSubject = prefix;
  } else {
    fullSubject = '';
  }
  
  const { customizeMessage } = this.state;

  const handleCancel = () => {
    this.setState({
      showEmailModal: false,
      invoiceEmails: [],
      // customizeMessage: false,
      emailAttachments: []
    });
  };

  const handleSubjectChange = (e) => {
    const inputValue = e.target.value;
    
    this.setState({
      subject: inputValue
    });
  };

  const footer = (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: "#EEF1FA"}}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', background: '#F5F7FB',padding: '10px 16px', borderRadius: '8px' }}>
        {(() => {
          const { totalSelected, totalOrders } = this.state.attachmentSummary;
          if (totalOrders > 0) {
            const attachmentSummary = `${totalSelected} attachment${totalSelected !== 1 ? 's' : ''} selected across ${totalOrders} order${totalOrders !== 1 ? 's' : ''}`;
            return (
              <>
                <Icon type="paper-clip" style={{ fontSize: '16px', color: '#595959' }} />
                <span style={{ fontSize: '14px', color: '#595959' }}>{attachmentSummary}</span>
              </>
            );
          }
          return null;
        })()}
      </div>
      <div style={{ textAlign: 'right' }}>
        <Button 
          data-testid="invoice-email-cancel-button"
          type="link" 
          onClick={handleCancel}
          style={{ marginRight: 8 }}
        >
          Cancel
        </Button>
        <Popconfirm
          placement="topRight"
          title={I18n.t('messages.confirm')}
          onConfirm={this.handleSendingMails}
          okText="Yes"
          cancelText="No"
        >
          <Button data-testid="invoice-email-send-button" type="primary" loading={this.state.isSendingMail}>
            Send Invoices
          </Button>
        </Popconfirm>
      </div>
    </div>
  );

  return (
    <BaseModal
      title={I18n.t("general.send_to", { from: I18n.t("general.invoice"), to: "Emails" })}
      onCancel={handleCancel}
      width="50%"
      style={{ top: 40 }}
      maskClosable={false}
      footer={footer}
    >
      <Spin spinning={this.state.isEmailLoading}>
        {/* Send To Section */}




          <>
            <Row className="tagsInput emailForm" data-testid="invoice-email-modal" type='flex' align='middle' gutter={8}>
              <Col span={24}>
                <FormItem label={I18n.t('general.email')}>
                  <Select
                    data-testid="invoice-email-dropdown"
                    value={this.state.invoiceEmails}
                    onChange={this.addInvoiceEmail}
                    mode="tags"
                    validationRegex={this.addInvoiceEmail}
                    style={{ width: "100%" }}
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    tokenSeparators={[","]}
                    placeholder="Enter email addresses (comma separated)"
                  >
                    {this.state.contacts.map(opt => <Select.Option key={opt}>{opt}</Select.Option>)}
                  </Select>
                </FormItem>
              </Col>
            </Row>

            {/* Customize Message Checkbox */}
            {/* <Row gutter={8} style={{ marginBottom: 16 }}>
              <Col span={24}>
                <Checkbox
                  checked={customizeMessage}
                  onChange={(e) => this.setState({ customizeMessage: e.target.checked })}
                  style={{ fontWeight: customizeMessage ? 'bold' : 'normal' }}
                >
                  Customize Message
                </Checkbox>
              </Col>
            </Row> */}


            {customizeMessage && (
              <>
                <Row>
                  <Col>
                    <FormItem label={I18n.t("general.subject")}>
                      <Input
                        data-testid="invoice-subject-input"
                        rows={4}
                        placeholder={I18n.t("general.subject")}
                        className="sop-form-textArea"
                        value={fullSubject}
                        onChange={handleSubjectChange}
                      />
                    </FormItem>
                  </Col>
                  <Col>
                    <FormItem label="Message Body">
                      <TextArea
                        data-testid="invoice-description-input"
                        rows={4}
                        placeholder={I18n.t("general.description")}
                        className="sop-form-textArea"
                        value={this.state.description}
                        onChange={(e) => this.setState({ description: e.target.value })}
                      />
                    </FormItem>
                  </Col>
                </Row>
              </>
            )}
          </>
        
         <Row>
        <Col>
          <FormItem label="Select Attachments to Include from orders">
            <ChipCheckbox
              checked={this.state.categoryCounts.pods.total > 0 && this.state.categoryCounts.pods.selected === this.state.categoryCounts.pods.total}
              onChange={(val) => {
                if (this.attachmentsRef && this.attachmentsRef.current) {
                  this.attachmentsRef.current.handleCategorySelection('pods', val);
                }
              }}
              label={`PODs (${this.state.categoryCounts.pods.selected}/${this.state.categoryCounts.pods.total})`}
              dataTestId="invoice-pods-checkbox"
            />

            <ChipCheckbox
              checked={this.state.categoryCounts.signatures.total > 0 && this.state.categoryCounts.signatures.selected === this.state.categoryCounts.signatures.total}
              onChange={(val) => {
                if (this.attachmentsRef && this.attachmentsRef.current) {
                  this.attachmentsRef.current.handleCategorySelection('signatures', val);
                }
              }}
              label={`Signatures (${this.state.categoryCounts.signatures.selected}/${this.state.categoryCounts.signatures.total})`}
              dataTestId="invoice-signatures-checkbox"
            />

            <ChipCheckbox
              checked={this.state.categoryCounts.bols.total > 0 && this.state.categoryCounts.bols.selected === this.state.categoryCounts.bols.total}
              onChange={(val) => {
                if (this.attachmentsRef && this.attachmentsRef.current) {
                  this.attachmentsRef.current.handleCategorySelection('bols', val);
                }
              }}
              label={`BOLs (${this.state.categoryCounts.bols.selected}/${this.state.categoryCounts.bols.total})`}
              dataTestId="invoice-bols-checkbox"
            />

            <ChipCheckbox
              checked={this.state.categoryCounts.drivers.total > 0 && this.state.categoryCounts.drivers.selected === this.state.categoryCounts.drivers.total}
              onChange={(val) => {
                if (this.attachmentsRef && this.attachmentsRef.current) {
                  this.attachmentsRef.current.handleCategorySelection('drivers', val);
                }
              }}
              label={`Others (${this.state.categoryCounts.drivers.selected}/${this.state.categoryCounts.drivers.total})`}
              dataTestId="invoice-others-checkbox"
            />

          </FormItem>
        </Col>
      </Row>

            <Row>
              <Col span={24}>
                <Search
                  data-testid="invoice-orders-input"
                  placeholder='Search orders...'
                  style={{borderRadius : '16px'}}
                  onSearch={(value) => {
                    if (this.attachmentsRef && this.attachmentsRef.current) {
                      this.attachmentsRef.current.setSearchTerm(value);
                    }
                  }}
                  onChange={(e) => {
                    if (this.attachmentsRef && this.attachmentsRef.current) {
                      this.attachmentsRef.current.setSearchTerm(e.target.value);
                    }
                  }}
                />
              </Col>
            </Row>

        </Spin>
        <Spin spinning={this.state.isLoadingAttachments}>
          <InvoiceOrderAttachments
            ref={this.attachmentsRef}
            emailAttachments={this.state.emailAttachments}
            warehouseTimeZoneId={this.props.timeZoneId}
            warehouseTzShortName={this.props.timeZoneId ? (this.props.invoiceDetails?.order_tz_short_name || '') : ''}
            onSelectionChange={(data) => {
              // Update category counts when selection changes
              if (data && data.counts) {
                this.setState({ categoryCounts: data.counts });
              } else if (this.attachmentsRef && this.attachmentsRef.current) {
                // Fallback: get counts directly
                const counts = this.attachmentsRef.current.getCategoryCounts();
                if (counts) {
                  this.setState({ categoryCounts: counts });
                }
              }
              if (data && data.summary) {
                this.setState({ attachmentSummary: data.summary });
              } else if (this.attachmentsRef && this.attachmentsRef.current) {
                const summary = this.attachmentsRef.current.getTotalSelectedCount();
                if (summary) {
                  this.setState({ attachmentSummary: summary });
                }
              }
            }}
          />
        </Spin>
      </BaseModal>
    );
  }


  handleClosePreview = () => {
    if (this.state.blobUrl) {
      URL.revokeObjectURL(this.state.blobUrl);
    }
    if (this.state.files.length > 0) {
      this.state.files.forEach(file => {
        if (file.fileUrl) {
          URL.revokeObjectURL(file.fileUrl);
        }
      });
    }
    this.setState({
      showPreview: false,
      blobUrl: null,
      fileName: null,
      fileType: 'pdf',
      files: []
    });
  };

  render() {
    return (
      <React.Fragment>
        {this.state.renderType === 'icon' ? (
          <Tooltip title={I18n.t("general.views.detail")}>
            <img
              data-testid={`view-icon-${this.props?.rowReferenceIndex}`}
              src={expandIcon}
              className="expandIcon cursorPointer"
              onClick={this.showInvoiceForm}
              alt={I18n.t("general.expand")}
              style={{ width: 14, ...this.props.style }}
            />
          </Tooltip>
        ) : (
          <Link className={"anchor_cursor"} onClick={this.showInvoiceForm}>
            {this.state.invoiceNo}
          </Link>
        )}
        {this.state.showForm && this.renderFormModal()}
        {this.state.showEmailModal && this.renderEmailModal()}
        {this.state.showPreview && (
          this.state.files.length > 0 ? (
            <BaseModal
              title="Preview Files"
              visible={this.state.showPreview}
              onCancel={this.handleClosePreview}
              width="90%"
              style={{ top: 30 }}
              footer={null}
              destroyOnClose
            >
              <MixedGallery 
                files={this.state.files} 
                showPrintButton={true}
                showFileName={true}
                closeComponent={this.handleClosePreview}
                handlePrint = {printFile}
              />
            </BaseModal>
          ) : (
            <FilePreviewViewer 
              blobUrl={this.state.blobUrl} 
              fileName={this.state.fileName} 
              fileType={this.state.fileType}
              onClose={this.handleClosePreview}
            />
          )
        )}
      </React.Fragment>
    );
  }
}

export const ShowInvoice = withRouter((props) => {
  const { orgSettings : organizationSettings , currentOrg }= useContext(OrgContext);
  const { orgRules } = useContext(UserContext);
  return (
    <ShowInvoiceComponent
      orgRules={orgRules}
      organizationSettings={organizationSettings}
      currentOrg={currentOrg}
      {...props}
    />
  );
});

export default withRouter(ShowInvoice)



ShowInvoice.propTypes = {
  refreshList: PropTypes.func,
  showInvoiceActions: PropTypes.bool,
  showActions:  PropTypes.bool,
  customerOrderIds: PropTypes.array
};

ShowInvoice.defaultProps = {
  refreshList: () => {},
  showInvoiceActions: true,
  inBillingScreen: false,
  customerOrderIds: []
};